import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.10583 18.8944C8.9136 22.7022 15.0866 22.7022 18.8944 18.8944C22.7022 15.0866 22.7022 8.9136 18.8944 5.10583C15.0866 1.29806 8.9136 1.29806 5.10583 5.10583C1.29806 8.9136 1.29806 15.0866 5.10583 18.8944ZM15.4013 9.34847C15.4012 9.14972 15.3222 8.95914 15.1816 8.8186C15.0411 8.67807 14.8505 8.59906 14.6518 8.59893L10.4091 8.59894C10.3085 8.59538 10.2081 8.61214 10.1141 8.64821C10.0201 8.68427 9.93424 8.73891 9.86178 8.80887C9.78931 8.87882 9.73168 8.96265 9.69232 9.05535C9.65296 9.14806 9.63267 9.24775 9.63267 9.34847C9.63267 9.44919 9.65296 9.54887 9.69232 9.64158C9.73168 9.73429 9.78931 9.81812 9.86178 9.88807C9.93424 9.95802 10.0201 10.0127 10.1141 10.0487C10.2081 10.0848 10.3085 10.1016 10.4091 10.098L12.8416 10.098L8.81814 14.1214C8.67748 14.2621 8.59847 14.4529 8.59847 14.6518C8.59847 14.8507 8.67748 15.0414 8.81814 15.1821C8.95879 15.3228 9.14955 15.4018 9.34847 15.4018C9.54738 15.4018 9.73815 15.3228 9.8788 15.1821L13.9022 11.1587L13.9022 13.5911C13.9091 13.7853 13.9911 13.9693 14.1309 14.1043C14.2707 14.2392 14.4574 14.3147 14.6518 14.3147C14.8461 14.3147 15.0328 14.2392 15.1727 14.1043C15.3125 13.9693 15.3944 13.7853 15.4013 13.5911L15.4013 9.34847Z"
        fill={colorValue}
      />
    </svg>
  );
};
